// ── Тексты интерфейса ────────────────────────────────────────────────────────
//
// Интерфейс ВСЕГДА русский. Ключ — это сам русский текст в коде, поэтому t()
// в большинстве случаев возвращает то же, что получил.
//
// Словарь ru.js нужен для другого: часть строк исторически написана в коде
// по-узбекски, и он переводит ИХ на русский. Без него такие места остались бы
// узбекскими.
//
// Узбекский словарь убран намеренно. Он был заполнен частично, и страница
// выходила лоскутной: заголовки и подписи русские (перевода нет), а отдельные
// строки вдруг узбекские. Это читалось не как перевод, а как сбой. Дополнять
// словарь до конца смысла нет — он всё равно отстаёт от нового кода.

import { RU } from './ru';

export const getLang = () => 'ru';

// Ключ — исходный текст из кода. Нет в словаре — отдаём как есть, ничего
// не теряется.
export const t = (s) => {
  const v = RU[s];
  return v === undefined ? s : v;
};

// Оставлено, чтобы старые вызовы не падали: язык больше не переключается.
export const setLang = () => {};

export const LANGS = [
  { code: 'ru', label: 'RU', name: 'Русский' },
];
